import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AdminNavbar from "../Navbars/AdminNavbar";
import AdminFooter from "../Footers/AdminFooter";
import Sidebar from "./sidebar";
import routes from "../../routes";
import Logo from "../../assets/images/car-service.png";
import TrackVehicle from "../trackvehicle/trackvehicle";

class Dashboard extends React.Component {
  componentDidUpdate(e) {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.mainContent.scrollTop = 0;
  }

  getRoutes = (routes) => {
    return routes.map((prop, key) => {
      return (
        <Route
          path={prop.path}
          render={(props) => {
            return (
              <prop.component
                {...props}
              />
            );
          }}
          key={key}
        />
      );
    });
  };

  getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (this.props.location.pathname.indexOf(routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
    return "Brand";
  };
  render() {
    return (
      <>
        <Sidebar
          {...this.props}
          routes={routes}
          logo={{
            innerLink: "/dashboard",
            imgSrc: Logo,
            imgAlt: "...",
          }}
        />
        <div className="main-content" ref="mainContent">
          <AdminNavbar
            {...this.props}
            brandText={this.getBrandText(this.props.location.pathname)}
          />
          <Switch>
            {this.getRoutes(routes)}
            <Route
              path="/trackvehicle"
              component={(props) => (
                <TrackVehicle {...props} dashboardData={[]} />
              )}
            />
            <Redirect from="*" to="/dashboard" />
          </Switch>
          <Container className="pb-4">
            {/* <AdminFooter /> */}
          </Container>
        </div>
      </>
    );
  }
}

export default Dashboard;
